import ArticleCard from '@/components/base/ArticleCard';
import { hotTopics } from '@/mocks/home';

export default function HotTopicsGrid() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <h2 className="text-3xl md:text-4xl font-heading text-foreground-900 mb-3">
            51 热榜焦点
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            全网最热话题排行，每日实时更新
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {hotTopics.map((topic) => (
            <ArticleCard
              key={topic.slug}
              slug={topic.slug}
              title={topic.title}
              excerpt={topic.excerpt}
              category={topic.category}
              categorySlug={topic.categorySlug}
              imageUrl={topic.imageUrl}
              date={topic.date}
              readCount={topic.readCount}
              hotIndex={topic.hotIndex}
            />
          ))}
        </div>
      </div>
    </section>
  );
}